import template from './procedure-detail.html';
import controller from './procedure-detail.controller';

let procedureDetailComponent = {
  bindings: {},
  template,
  controller
};

export default procedureDetailComponent;



// WEBPACK FOOTER //
// ./client/app/components/procedure/procedure-detail.component.js